module.exports = __webpack_public_path__ + "static/media/logo.d879efa1.svg";